var React = require('react');

function IndonesiaRound (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"indonesia-round"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"indonesia-round","fillRule":"nonzero"},[React.createElement("circle",{"id":"Oval","fill":"#F2F2F2","cx":"8","cy":"8","r":"8","key":0}),React.createElement("path",{"d":"M0,8 C0,3.58175 3.58175,0 8,0 C12.41825,0 16,3.58175 16,8","id":"Path","fill":"#CE1126","key":1})]))]);
}

IndonesiaRound.defaultProps = {"width":"16px","height":"16px","viewBox":"0 0 16 16","version":"1.1"};

module.exports = IndonesiaRound;

IndonesiaRound.default = IndonesiaRound;
